import { render, staticRenderFns } from "./IconFontWrapper.vue?vue&type=template&id=ca5b1c7e&"
import script from "./IconFontWrapper.vue?vue&type=script&lang=js&"
export * from "./IconFontWrapper.vue?vue&type=script&lang=js&"
import style0 from "./IconFontWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca5b1c7e')) {
      api.createRecord('ca5b1c7e', component.options)
    } else {
      api.reload('ca5b1c7e', component.options)
    }
    module.hot.accept("./IconFontWrapper.vue?vue&type=template&id=ca5b1c7e&", function () {
      api.rerender('ca5b1c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/IconFontWrapper.vue"
export default component.exports